import { render, staticRenderFns } from "./selectAy.vue?vue&type=template&id=4f070c3d&scoped=true&"
import script from "./selectAy.vue?vue&type=script&lang=js&"
export * from "./selectAy.vue?vue&type=script&lang=js&"
import style0 from "./selectAy.vue?vue&type=style&index=0&id=4f070c3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f070c3d",
  null
  
)

export default component.exports